import { ProjectCoreLang } from '@aipb/gulliver/castor/model';
import { Topic, TopicRegisterItem } from '@aipb/gulliver/catalog/model';
import { SimpleCardComponent } from '@aipb/shared/ui/card';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { TopicRegisterListComponent } from '../topic-register-list/topic-register-list.component';

@Component({
  selector: 'cat-topic-item',
  templateUrl: './topic-item.component.html',
  styleUrls: ['./topic-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SimpleCardComponent,
    MatDividerModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslocoModule,
    TopicRegisterListComponent,
    MatCardModule
]
})
export class TopicItemComponent {
  @Input() topic?: Topic;
  @Input() topicRegisterItems: TopicRegisterItem[] = [];
  @Input() cores: ProjectCoreLang[] = [];
  @Input() activeCoreId: string;

  @Output() search = new EventEmitter<[Topic, TopicRegisterItem]>();
  @Output() changeCoreId = new EventEmitter<string>();
}
